module.exports = __webpack_public_path__ + "static/img/message_empty_fail.1114331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/message_empty_fail.png
// module id = Vh0I
// module chunks = 18